export default "__VITE_ASSET__BVNOIIhm__"